import { Component } from '@angular/core';

@Component({
  selector: 'app-shop-aboutus',
  templateUrl: './shop-aboutus.component.html',
  styleUrls: ['./shop-aboutus.component.css']
})
export class ShopAboutusComponent {
// Set Topbar
  Menuoption = 'shop'
  footerVariant = 'footer-two';

/***
 * Header button list show
 */
shopPages = true;

}
